import {
  Alert,
  Box,
  Breadcrumbs,
  LinearProgress,
  Link as MLink,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import OnlineTourDetailContainer from '../container/OnlineTourDetailContainer';
import { useTourSearchDetail } from '../hooks/api/tour-search';
import { HomeTwoTone } from '@mui/icons-material';

function TourDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data, isLoading } = useTourSearchDetail({
    id: parseInt(id as string),
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !data) {
      setTimeout(() => {
        navigate('/home');
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <Box>
      <Breadcrumbs sx={{ mb: 1 }}>
        <MLink
          component={Link}
          to="/"
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <HomeTwoTone />
        </MLink>
        <MLink
          component={Link}
          to="/tours"
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          {t('nav.tours')}
        </MLink>
        <Typography>{t('nav.tourId', { tourId: id })}</Typography>
      </Breadcrumbs>

      {isLoading && <LinearProgress />}
      {!isLoading && !data && (
        <Box display="flex" textAlign="center" justifyContent="center" mt={5}>
          <Alert color="warning" severity="warning">
            {t('onlineTourDetail.undefinedTour')}
          </Alert>
        </Box>
      )}
      {!isLoading && (
        <>
          {data && (
            <OnlineTourDetailContainer
              data={data}
              tourId={parseInt(id as string)}
            />
          )}
        </>
      )}
    </Box>
  );
}

export default TourDetailPage;
